import { React } from 'react'
import { slug, icap, tr, getLang } from '../../../global-pure.js'
import PageLayout from '../../../containers/page/PageLayout.jsx'
import { Button } from '../../../components/page/Section.jsx'
import AskLink from '../../../components/AskLink.jsx'
import BugLink from '../../../components/BugLink.jsx'
import TryItNowLink from '../../../components/TryItNowLink.jsx'
import cardPic from '../../../assets/apps/ng-wallet1.jpg'
import screenshot1 from '../../../assets/apps/ng/wallet/screenshot-1.png'
import screenshot2 from '../../../assets/apps/ng/wallet/screenshot-2.png'
import screenshot3 from '../../../assets/apps/ng/wallet/screenshot-3.png'
import screenshot4 from '../../../assets/apps/ng/wallet/screenshot-4.png'
import screenshot5 from '../../../assets/apps/ng/wallet/screenshot-5.png'
import screenshot6 from '../../../assets/apps/ng/wallet/screenshot-6.png'
import screenshot7 from '../../../assets/apps/ng/wallet/screenshot-7.png'
import screenshot8 from '../../../assets/apps/ng/wallet/screenshot-8.png'
import Paragraph from '../../../components/page/Paragraph'
import { useState } from 'react'

export const card = {
  title: 'satsback:title',
  blurb: 'satsback:blurb',
  subtitle: 'satsback:subtitle',
  routeBuilder: () => `/${slug(tr('apps'))}/${slug(tr('satsback'))}`,
  imgUrl: cardPic,
  call: 'see features',
  // ask: <AskLink text={'purchase now'} prefill={'ant-s19j:question'} />
}

const SatsBack = () => {
  const [isChecked1, setIsChecked1] = useState(false)
  const [isChecked2, setIsChecked2] = useState(false)
  const [isChecked3, setIsChecked3] = useState(false)
  const [isChecked4, setIsChecked4] = useState(false)
  const [isChecked5, setIsChecked5] = useState(false)
  const [isChecked6, setIsChecked6] = useState(false)
  const [isChecked7, setIsChecked7] = useState(false)
  const handleOnChange1 = () => { setIsChecked1(!isChecked1) }
  const handleOnChange2 = () => { setIsChecked2(!isChecked2) }
  const handleOnChange3 = () => { setIsChecked3(!isChecked3) }
  const handleOnChange4 = () => { setIsChecked4(!isChecked4) }
  const handleOnChange5 = () => { setIsChecked5(!isChecked5) }
  const handleOnChange6 = () => { setIsChecked6(!isChecked6) }
  const handleOnChange7 = () => { setIsChecked7(!isChecked7) }
  const cost=50000
    /(isChecked1?2:1)
    /(isChecked2?2:1)
    /(isChecked3?2:1)
    /(isChecked4?2:1)
    /(isChecked5?2:1)
    /(isChecked6?2:1)
    /(isChecked7?2:1)
  return (
    <PageLayout>
      <div className='side-divider'>
        <div className='content'>
          <h1>{icap(tr(card.title))}</h1>
          <h2>{tr(card.subtitle)}</h2>
          <p><i>{tr('satsback:instruction')}</i></p>
          <span className='SATOSHI'>S</span>
          <div className='SATOSHI'>
            <h4>{icap(tr('SATOSHI:spend'))}</h4>
            <label><p><input type='checkbox' checked={isChecked1} onChange={handleOnChange1} />{tr('SATOSHI:spend-q')}</p></label>
          </div>
          <span className='SATOSHI'>A</span>
          <div className='SATOSHI'>
            <h4>{icap(tr('SATOSHI:acquire'))}</h4>
            <label><p><input type='checkbox' checked={isChecked2} onChange={handleOnChange2} />{tr('SATOSHI:acquire-q')}</p></label>
          </div>
          <span className='SATOSHI'>T</span>
          <div className='SATOSHI'>
            <h4>{icap(tr('SATOSHI:tend'))}</h4>
            <label><p><input type='checkbox' checked={isChecked3} onChange={handleOnChange3} />{tr('SATOSHI:tend-q')}</p></label>
          </div>
          <span className='SATOSHI'>O</span>
          <div className='SATOSHI'>
            <h4>{icap(tr('SATOSHI:onboard'))}</h4>
            <label><p><input type='checkbox' checked={isChecked4} onChange={handleOnChange4} />{tr('SATOSHI:onboard-q')}</p></label>
          </div>
          <span className='SATOSHI'>S</span>
          <div className='SATOSHI'>
            <h4>{icap(tr('SATOSHI:save'))}</h4>
            <label><p><input type='checkbox' checked={isChecked5} onChange={handleOnChange5} />{tr('SATOSHI:save-q')}</p></label>
          </div>
          <span className='SATOSHI'>H</span>
          <div className='SATOSHI'>
            <h4>{icap(tr('SATOSHI:honor'))}</h4>
            <label><p><input type='checkbox' checked={isChecked6} onChange={handleOnChange6} />{tr('SATOSHI:honor-q')}</p></label>
          </div>
          <span className='SATOSHI'>I</span>
          <div className='SATOSHI'>
            <h4>{icap(tr('SATOSHI:interconnect'))}</h4>
            <label><p><input type='checkbox' checked={isChecked7} onChange={handleOnChange7} />{tr('SATOSHI:interconnect-q')}</p></label>
          </div>
          <p>
            {icap(tr('satsback:dues'))}
            <span style={{fontWeight: 1000, color: 'red'}}>{Intl.NumberFormat(getLang()).format(Math.floor(cost))} PYG</span>
          </p>
          <p>
            {icap(tr('satsback:refund'))}
            <span style={{fontWeight: 1000}}>{Intl.NumberFormat(getLang()).format(Math.floor(50000-cost))} PYG</span>
          </p>
          <p>{icap(tr('Questions?'))}{' '}<AskLink /></p>
          <p>{icap(tr('Bugs?'))}{' '}<BugLink /></p>
        </div>
      </div>

  </PageLayout>
)
}

export default SatsBack